import React from "react";
import i18n from "i18next";

import { api } from "@/utils/api";

class PolicyInquirySection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contentList: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    Promise.all([
      api.agreement.getPublishPrivacyPolicy(),
      api.agreement.getPublishInquiry(),
    ])
      .then((result) => {
        this.setState({
          contentList: [result[0][0], result[1][0]],
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  render() {
    const { contentList } = this.state;
    return (
      <div className="policy-inquiry-container">
        {contentList.map((item, index) => (
          <React.Fragment key={index}>
            <div className="title">{item.loginTitle}</div>
            <div
              dangerouslySetInnerHTML={{
                __html: item.contentText,
              }}
            />
            {index < contentList.length - 1 && (
              <div className="line margin-top-title margin-bottom-title" />
            )}
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default PolicyInquirySection;
